export default "__VITE_ASSET__W0FMa6WG__"